import React, { useState } from "react";
import { Form, Upload, message, Progress } from "antd";
import GainIcon from "./gainicon";
import { useEffect } from "react";
import { baseURL } from "../config";

const { Dragger } = Upload;

export default function UploadFile({ value, onChange }) {
  const bytesToSize = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const [previewFile, setPreviewFile] = useState(null);

  const props = {
    name: "file",
    accept:
      ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    action: `${baseURL}/api/excel/upload`,
    headers: {
      contentType: "multipart/form-data",
    },
    showUploadList: false,
  };

  const normFile = (info) => {
    const { status } = info.file;
    setPreviewFile(info.file);
    onChange(info.file);
    if (status === "done") {
      return info.file.response.name;
    }
  };

  useEffect(() => {
    if (!value) {
      setPreviewFile(null);
    }
  }, [value]);

  return (
    <div>
      <div
        className="text-center rounded-lg py-6"
        style={{ backgroundColor: "#f2f4fd" }}
      >
        <h1 className="text-xl font-bold">Data Spreadsheet</h1>
        <p>
          Just drag and drop the files
          <br /> and assign to right folder.
        </p>
        <div className="px-12">
          <Form.Item
            name="file_name"
            getValueFromEvent={normFile}
            rules={[{ required: true, message: "Please input scinario name!" }]}
          >
            <Dragger {...props}>
              <GainIcon name="upload" />
              <p>Drag or upload files</p>
            </Dragger>
          </Form.Item>
        </div>
      </div>
      {previewFile && (
        <div
          className="w-full rounded-lg flex justify-between items-center px-3 py-3 mt-3"
          style={{ background: "#EBF8F5" }}
        >
          <div
            className="leading-6 flex flex-col font-light"
            style={{ color: "#07A287" }}
          >
            <span className="text-base font-normal">{previewFile.name}</span>
            <span>{bytesToSize(previewFile.size)}</span>
          </div>
          <div>
            {previewFile.percent === 100 || previewFile.status === "error" ? (
              <div
                className="cursor-pointer"
                onClick={() => setPreviewFile(null)}
              >
                <GainIcon name="delete-green" />
              </div>
            ) : (
              <Progress
                trailColor="#fff"
                type="circle"
                percent={parseInt(previewFile.percent)}
                width={30}
                strokeColor="#07A287"
                strokeWidth={8}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
}
